<template>
  <div id="tradingTool">
    <div class="tradingTool" v-if="toShowSub()">
      <router-view></router-view>
      <div class="deposit" v-if="toShowDeposit()">
        <div class="how">{{ getHow() }}</div>
        <div class="minimum">
          <img src="@/assets/images/tradingTools/icons/minimum.png" alt="" />
          <div class="sub_text">{{ getNote1() }}</div>
        </div>
        <div class="minimum">
          <img src="@/assets/images/tradingTools/icons/conditions.png" alt="" />
          <div class="sub_text">{{ getNote2() }}</div>
        </div>
        <div class="btn_box">
          <a
            :href="getDownloadLink"
            target="_blank"
            class="deposit_btn"
            data-testid="tradingToolsDownload"
            v-if="ASCNotNeedDeposit()"
          >
            {{ $t('proTraderTools.condition.downloadNow') }}
          </a>
          <div class="deposit_btn" v-else @click.stop.prevent="getDepositBlacklist()">
            {{ $t('proTraderTools.condition.depositNow') }}
          </div>
        </div>
      </div>

      <div class="check" v-if="toShowCheck()">
        <div class="tick_box">
          <img src="@/assets/images/tradingTools/icons/continue_flag.png" alt="" />
          <el-form :model="form" :rules="rule" ref="tradingToolForm" :show-message="false">
            <p>You're almost there, tick the box to complete the final step.</p>
            <el-form-item prop="checked">
              <el-checkbox v-model="form.checked" data-testid="checkbox">
                <i18n path="tradingTools.condition.needTnc">
                  <template v-slot:link>
                    <a
                      :href="`https://www.vtmarkets.com/protrader-tnc/`"
                      target="_blank"
                      style="color: #0053ff"
                      data-testid="link"
                    >
                      {{ $t('tradingTools.condition.link') }}
                    </a>
                  </template>
                </i18n>
              </el-checkbox>
            </el-form-item>
            <br />
          </el-form>
        </div>

        <div class="form_button">
          <el-button class="el-button blue_button" @click="onSubmit" data-testid="unlock"> Continue </el-button>
        </div>
      </div>
    </div>
    <iframe v-else frameborder="no" border="0" :src="path"></iframe>
  </div>
</template>

<script>
import mixin from '@/mixins/tradingTool';
import { PROTRADER_HOWTOTRADE_LINK } from '@/constants/thirdPartyLink';

export default {
  name: 'tradingTools',
  mixins: [mixin],
  data() {
    return {};
  },
  computed: {
    isHowToTrade() {
      return this.$route.fullPath === '/tradingTool/HOW_TRADE';
    },
    isAcuitySignalCentre() {
      return this.$route.fullPath === '/tradingTool/AS_CENTRE';
    },
    isLangCh() {
      return ['zh_CN', 'zh_TW'].includes(this.$i18n.locale);
    },
    getDownloadLink() {
      return this.isLangCh
        ? 'https://www.vtmarkets.com/VTMarkets_MetaTrader_Expert_Advisor_Installation_Guide_CH'
        : 'https://www.vtmarkets.com/VTMarkets_MetaTrader_Expert_Advisor_Installation_Guide';
    },
    howTo() {
      return {
        1: 'How to access HowtoTrade training room for free',
        2: this.$t('proTraderTools.acuitySignalCentre.inEligible.howTo.title'),
        3: this.$t('proTraderTools.acuitySignalCentre.eligible.howTo.title'),
        4: 'How to access ProTrader Tools:'
      };
    },
    note1() {
      return {
        1: '1. Ensure that your trading account is funded with a minimum of $100 every month.',
        2: this.$t('proTraderTools.acuitySignalCentre.inEligible.howTo.note1'),
        3: this.$t('proTraderTools.acuitySignalCentre.eligible.howTo.note1', { minLimit: this.minLimit })
      };
    },
    note2() {
      return {
        1: this.$t('proTraderTools.acuitySignalCentre.inEligible.howTo.note2'),
        2: this.$t('proTraderTools.acuitySignalCentre.eligible.howTo.note2')
      };
    }
  },
  methods: {
    getHow() {
      switch (true) {
        case this.isHowToTrade:
          return this.howTo[1];
        case this.ASCNeedDeposit():
          return this.howTo[2];
        case this.ASCNotNeedDeposit():
          return this.howTo[3];
        default:
          return this.howTo[4];
      }
    },
    getNote1() {
      switch (true) {
        case this.isHowToTrade:
          return this.note1[1];
        case this.ASCNeedDeposit():
          return this.note1[2];
        default:
          return this.note1[3];
      }
    },
    getNote2() {
      switch (true) {
        case this.ASCNeedDeposit():
          return this.note2[1];
        default:
          return this.note2[2];
      }
    },
    ASCNeedDeposit() {
      return this.isAcuitySignalCentre && this.needDeposit;
    },
    ASCNotNeedDeposit() {
      return this.isAcuitySignalCentre && !this.needDeposit;
    },
    toShowSub() {
      switch (true) {
        case this.isHowToTrade:
          this.path = PROTRADER_HOWTOTRADE_LINK;
          return this.needDepositHowToTrade;
        case this.isAcuitySignalCentre:
          return true;
        default:
          return (this.needDeposit && this.needUnlock) || this.needAccept;
      }
    },
    toShowDeposit() {
      switch (true) {
        case this.isHowToTrade:
          return this.needDepositHowToTrade;
        case this.isAcuitySignalCentre:
          return true;
        default:
          return this.needDeposit && this.needUnlock;
      }
    },
    toShowCheck() {
      return !(this.needDeposit && this.needUnlock) && !this.isHowToTrade && !this.isAcuitySignalCentre;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/tradingTools.scss';
</style>
